import { Component, Input } from '@angular/core';
import { TableComponent } from '../../core/table/table.component';
import { ColumnComponent } from '../../core/table/column.component';

@Component({
  selector: 'app-policy-layer',
  imports: [TableComponent, ColumnComponent],
  template: ` <app-table
    [pageSize]="5"
    [scrollable]="false"
    [expandable]="true"
    dataKey="id"
    recordLabel="Layer Group"
    [dataSource]="dataSource"
    [stripedRows]="false"
  >
    <app-column
      name="layerGroupNumber"
      label="Group Number"
      format="n"
      width="15%"
    />
    <app-column name="layerGroupName" label="Group Name" width="25%" />
    <app-column
      name="aggregateLimit"
      label="Aggregate Limit"
      format="c"
      width="20%"
    />
    <app-column name="layerGroupType" label="Group Type" width="20%" />
    <app-column
      name="coveredPartyType"
      label="Covered Party Type"
      format="n"
      width="20%"
    />
    <ng-template #expand let-data>
      <div class="tw-p-4">
        <app-table
          [pageSize]="5"
          [scrollable]="false"
          [expandable]="true"
          dataKey="id"
          recordLabel="Layer"
          [dataSource]="data.layers"
          theme="Dark"
          [stripedRows]="false"
        >
          <app-column name="layerLevel" label="Level" width="20%" />
          <app-column name="payCategory" label="Pay Category" width="15%" />
          <app-column
            name="aggregateLimit"
            label="Aggregate Limit"
            width="15%"
            format="c"
          />
          <app-column
            name="occurrenceLow"
            label="Occurrence Low"
            width="15%"
            format="c"
          />
          <app-column
            name="occurrenceHigh"
            label="Occurrence High"
            width="15%"
            format="c"
          />
          <app-column name="reportLevel" label="Report Level" width="20%" />
          <ng-template #expand let-data>
            <div class="tw-p-4">
              <app-table
                [scrollable]="false"
                recordLabel="Participant"
                [dataSource]="data.participants"
                [stripedRows]="false"
              >
                <app-column
                  name="carrierCode"
                  label="Carrier Code"
                  width="25%"
                />
                <app-column
                  name="carrierName"
                  label="Carrier Name"
                  width="25%"
                />
                <app-column
                  name="bankNumber"
                  label="Bank Number"
                  width="25%"
                  format="n"
                />
                <app-column
                  name="percentage"
                  label="Percentage"
                  width="25%"
                  format="%"
                />
              </app-table>
            </div>
          </ng-template>
        </app-table>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class PolicyLayerComponent {
  @Input() dataSource: any;
}
